﻿import * as $ from 'jquery';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { IResourceProvider } from 'common/resourceprovider';
import { WorkItemNotAvailableForClaim, ClaimFailureReason } from 'runtime/messages/workitemnotavailableforclaim';
import { format } from 'common/functions/string';

export enum OpenOption {
    None,
    OpenReadOnly,
    TransferAndEdit,
    ForceCancelAndEdit
}

export class OpenOptionsDialog implements IDialog {
    options: IDialogOptions;
    private dialogContent: JQuery;

    constructor(private resources: IResourceProvider, serverMessage: WorkItemNotAvailableForClaim, action: (x: OpenOption) => void, closeAction?: () => void) {
        this.options = {
            title: resources.getCoreString('MsgOpenWorkItem'),
            width: 600,
            height: 300,
            dialogClass: 'wf-worktray-item-dialog',
            buttons: [
                { text: resources.getCoreString('XamlClose'), click: () => this.actAndClose(closeAction) }
            ],
            create: () => {
                $('.ui-dialog-buttonset > button', this.dialogContent.parent()).css('min-width', '80px');
            }
        }

        var readOnlyAvailable = ((serverMessage.reason === ClaimFailureReason.stepCompleted || serverMessage.reason === ClaimFailureReason.claimedByAnotherUser) && serverMessage.workItemInfo && serverMessage.workItemInfo.canView);
        var transferAvailable = (serverMessage.reason === ClaimFailureReason.claimedByAnotherUser && serverMessage.workItemInfo.canTransfer);
        var forceCancelAvailable = (serverMessage.reason === ClaimFailureReason.claimedByAnotherUser && serverMessage.workItemInfo.canForceCancel && serverMessage.workItemInfo.state === 'claimed');
        var actionHeaderVisible = (readOnlyAvailable || transferAvailable || forceCancelAvailable);

        var message = (serverMessage.reason === ClaimFailureReason.stepCompleted) ? resources.getCoreString('MsgClaimFailureReasonStepCompleted')
            : (serverMessage.reason === ClaimFailureReason.claimedByAnotherUser) ? format(resources.getCoreString('MsgClaimFailureReasonClaimedByAnotherUser'), serverMessage.workItemInfo.claimUserInfo.displayName)
            : resources.getCoreString('MsgClaimFailureReasonDefault');

        this.dialogContent = $('<div />').addClass('wf-open-options-content').append([
            $('<div />').addClass('wf-open-options-caption').append($('<div />').text(message)),
            this.constructOptionHeader(actionHeaderVisible),
            this.constructOption(readOnlyAvailable, () => resources.getCoreString('MsgOpenTheWorkItemInReadOnlyMode'), 'XamlReadOnly', () => action(OpenOption.OpenReadOnly)),
            this.constructOption(transferAvailable, () => format(resources.getCoreString('MsgClaimFailureReasonClaimedByAnotherUserTransfer'), serverMessage.workItemInfo.claimUserInfo.displayName), 'XamlTransfer', () => action(OpenOption.TransferAndEdit)),
            this.constructOption(forceCancelAvailable, () => format(resources.getCoreString('MsgClaimFailureReasonClaimedByAnotherUserCancel'), serverMessage.workItemInfo.claimUserInfo.displayName), 'XamlForceCancel', () => action(OpenOption.ForceCancelAndEdit))
        ]);
    }

    private constructOptionHeader(condition: boolean) {
        return !condition
            ? $()
            : $('<div />').addClass('wf-open-options-header').append(
                $('<div />').text(this.resources.getCoreString('MsgYouMay'))
            );
    }

    private constructOption(condition: boolean, messageFactory: () => string, buttonResource: string, action: () => void) {
        return !condition
            ? $()
            : $('<div />').addClass('wf-open-options-action').append([
                $('<div />').addClass('wf-open-options-action-text').append($('<div/>').text(messageFactory())),
                $('<div />').addClass('wf-open-options-action-button').append($('<button />').on('click', () => this.actAndClose(action)).text(this.resources.getCoreString(buttonResource)))
            ]);
    }

    content(): JQuery {
        return this.dialogContent;
    }

    private close(): void {
        this.dialogContent.dialog('close');
    }

    private actAndClose(action: () => void) {
        if(action)
            action();

        this.close();
    }
}